import { gql } from '@apollo/client';

export const CREATE_PRODUCT_PACKAGING = gql`
  mutation CreateProductPackaging($input: CreateProductPackagingInput!) {
    createProductPackaging(input: $input) {
      message
      productPackaging {
        id
        productName
        quantity
        packagingBindis {
          key
          qty
        }
        product {
          id
          name
        }
        createdAt
      }
    }
  }
`;

export const UPDATE_PRODUCT_PACKAGING = gql`
  mutation UpdateProductPackaging(
    $where: UniqueWhereInput!
    $input: UpdateProductPackagingInput!
  ) {
    updateProductPackaging(where: $where, input: $input) {
      message
      productPackaging {
        id
        productName
        quantity
        packagingBindis {
          key
          qty
        }
        product {
          id
          name
        }
        updatedAt
      }
    }
  }
`;

export const DELETE_PRODUCT_PACKAGING = gql`
  mutation DeleteProductPackaging($where: UniqueWhereInput!) {
    deleteProductPackaging(where: $where) {
      message
    }
  }
`;